import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { Validators, DatePickerField } from './Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import {compose} from 'redux';

type ConnectedProps = {
    t?: Function;
};

const ActiveTerminalsReportForm = (props: InjectedFormProps & ConnectedProps) => {
    const { handleSubmit, pristine, submitting, t} = props;
    return (
        <form className="form date-padding" onSubmit={handleSubmit}>
            <Field
                name="forDate"
                component={DatePickerField}
                allowPastDates={true}
                type="text"
                placeholder={t('forDate')}
                label={t('forDate')}
                validate={[Validators.required]}
                dateRangePlaceholder={t('dateRangePlaceholder')}
            />
            <div className="form__fields-wrapper form__fields-wrapper--center">
                <button disabled={submitting || pristine} className="btn btn--blue" type="submit">
                    {t('generateReport')}
                </button>
            </div>
        </form>
    );
};

export default compose(
    withTranslation (['forms', 'errors', 'carDetails']),
    reduxForm({
        form: 'CarMainReport',
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    })
)(ActiveTerminalsReportForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/ActiveTerminalsReportForm.tsx